
























































import { Component, Vue, Watch } from "vue-property-decorator";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src
import MenuList from "@/components/MenuList.vue";
import Carousel from "@/components/carousel.vue";
import { Route, RawLocation } from "vue-router";

@Component({
  components: {
    HelloWorld,
    MenuList,
    Carousel
  }
})
export default class Home extends Vue {
  public collapsed = true;
  public companyName = "";
  public menuId: any="";
  constructor(
  ) {
    super();
    // this.menuId == Route.path;
  }
  @Watch("$route", { deep: true })
  private onChildChanged(val: Route, oldVal: Route) {
    console.log(val.path);
    this.menuId = val.path;
  }
  mounted() {
    this.menuId=this.$route.path;
    this.companyName = localStorage.getItem("companyName") || "";
  }
  loginOut() {
    localStorage.removeItem("token");
    localStorage.removeItem("companyName");
    this.$router.push("/login");
  }
}
